import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { groupParticipation as groupParticipationSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectEntities } from './entities.js';

// API Actions

const RETRIEVE_GROUP_PARTICIPATIONS_REQUEST =
  'changesync/groupParticipations/RETRIEVE_GROUP_PARTICIPATIONS_REQUEST';
const RETRIEVE_GROUP_PARTICIPATIONS_SUCCESS =
  'changesync/groupParticipations/RETRIEVE_GROUP_PARTICIPATIONS_SUCCESS';
const RETRIEVE_GROUP_PARTICIPATIONS_FAILURE =
  'changesync/groupParticipations/RETRIEVE_GROUP_PARTICIPATIONS_FAILURE';

// Initial State

const initialState = {
  /**
   * @property {object} participationsIds
   * Arrays of participations IDs indexed by stakeholder ID
   * @example
   * {
   *   [stakeholderId]: [participationId, participationId, ...]
   * }
   */

  participationIds: {},
  query: '',
  pending: false,
  success: false,
  error: null,
};

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_GROUP_PARTICIPATIONS_REQUEST:
      return {
        ...state,
        pending: true,
        success: false,
        error: null,
      };
    case RETRIEVE_GROUP_PARTICIPATIONS_SUCCESS:
      return {
        ...state,
        participationIds: {
          ...state.participationIds,
          [action.meta.stakeholderId]: action.payload.result,
        },
        pending: false,
        success: true,
      };
    case RETRIEVE_GROUP_PARTICIPATIONS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Action Creators
export const retrieveGroupParticipations = (stakeholderId) => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_GROUP_PARTICIPATIONS_REQUEST,
        RETRIEVE_GROUP_PARTICIPATIONS_SUCCESS,
        RETRIEVE_GROUP_PARTICIPATIONS_FAILURE,
      ],
      endpoint: `stakeholders/${stakeholderId}/group_participations`,
      method: HTTP_METHODS.GET,
      schema: [groupParticipationSchema],
    },
    meta: {
      stakeholderId,
    },
  });
};

// Selectors
const selectGroupParticipationsIds = (state, props) =>
  state.groupParticipations.participationIds[props.stakeholderId];

export const selectGroupParticipations = createSelector(
  selectGroupParticipationsIds,
  selectEntities,
  (groupParticipationsIds, entities) =>
    denormalize(groupParticipationsIds, [groupParticipationSchema], entities)
);
